<template>
  <div>
    <assessments-desktop v-if="screenType === 'desktop'"></assessments-desktop>
    <assessments-mobile v-else></assessments-mobile>
  </div>
</template>

<script>
import AssessmentsDesktop from "@/components/Pages/Desktop/Dashboard/AssessmentsDesktop";
import AssessmentsMobile from "@/components/Pages/Mobile/Dashboard/AssessmentsMobile";

export default {
  name: "AssessmentsMain",
  components: {AssessmentsMobile, AssessmentsDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>